import { render, staticRenderFns } from "./TwoFactorModal.vue?vue&type=template&id=2f8b35e6&scoped=true"
import script from "./TwoFactorModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorModal.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorModal.vue?vue&type=style&index=0&id=2f8b35e6&prod&scoped=true&lang=css"
import style1 from "./TwoFactorModal.vue?vue&type=style&index=1&id=2f8b35e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b35e6",
  null
  
)

export default component.exports